module.exports = __webpack_public_path__ + "img/club-create.79a16a58.png";